import type { BaseListQuery, BaseListQueryDto } from '../types';

export function mapBaseListQueryToDto(query: BaseListQuery): BaseListQueryDto {
  return {
    search: query.search,
    page: query.page,
    per_page: query.perPage,
    order_by: query.orderBy,
    order_dir: query.orderDir,
  };
}
